<div class="position-relative mt-48">
  <img
    class="position-absolute img-fluid top-0 start-50 translate-middle-x z-n1"
    [src]="'/assets/img/importacao/table-gradient.svg'"
    alt=""
    width="760"
  />

  <div class="d-flex vstack align-items-center text-center pt-64">
    <div class="background rounded-circle p-3 mb-24">
      <img [src]="'/assets/img/importacao/csv.svg'" alt="" width="32" />
    </div>
    <h2 class="font-size-18 mb-1">Faça upload do arquivo CSV</h2>

    <div class="font-size-14 mb-24">
      <p class="mb-0">Aceito apenas arquivo .CSV</p>
    </div>
    <form [formGroup]="filesDataForm">
      <input
        [disabled]="firstLoading"
        type="file"
        class="form-control mb-16"
        accept=".csv"
        (change)="onFileChange($event)"
      />

      <button mat-flat-button (click)="onSubmit()" [disabled]="!filesDataForm.valid || firstLoading">
        Importar arquivo
      </button>
    </form>
  </div>
</div>
